import { User } from './user';

export class MaintenanceTaskConfigurationFile {
  constructor(
    public hash?: string,
    public fileName?: string,
    public filePath?: string,
    public fileMimeType?: string,
    public user?: User,
    public date?: number
  ) { }

  clone() {
    return new MaintenanceTaskConfigurationFile(
      this.hash,
      this.fileName,
      this.filePath,
      this.fileMimeType,
      this.user,
      this.date
    );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/maintenance-task-configuration-file.ts